export { default as Img200 } from './processed/200/Viddora.jpg';
export { default as Img400 } from './processed/400/Viddora.jpg';
export { default as Imgthumb } from './processed/thumb/Viddora.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Viddora.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Viddora.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      70,
      90,
      226
    ],
    "_population": 55,
    "_hsl": [
      0.6452991452991453,
      0.7289719626168223,
      0.580392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      133,
      148,
      247
    ],
    "_population": 129,
    "_hsl": [
      0.6447368421052632,
      0.8769230769230771,
      0.7450980392156863
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      94,
      51,
      43
    ],
    "_population": 664,
    "_hsl": [
      0.026143790849673203,
      0.37226277372262767,
      0.2686274509803922
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      127,
      117
    ],
    "_population": 592,
    "_hsl": [
      0.03472222222222224,
      0.2105263157894737,
      0.5529411764705883
    ]
  },
  "LightMuted": {
    "_rgb": [
      182,
      184,
      222
    ],
    "_population": 442,
    "_hsl": [
      0.6583333333333333,
      0.37735849056603776,
      0.7921568627450981
    ]
  },
  "DarkMuted": {
    "_rgb": [
      46,
      51,
      67
    ],
    "_population": 114,
    "_hsl": [
      0.626984126984127,
      0.1858407079646018,
      0.22156862745098038
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/viddora.js